import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Gallery, SocialNetworks } from 'src/app/utils/models';
import { environment } from 'src/environments/environment';

const headers = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable()
export class DashboardService {
  constructor(private readonly http: HttpClient) {}

  getUserDataById(idUsuario: number, idioma: string): Observable<any> {
    const body = { idUsuarioValor: idUsuario, idUsuario, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelPortada/datosUsuario'),
      body,
      headers
    );
  }

  createSaveAboutMe(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.post<any>(
      environment.api_qaapis.concat('api/PanelSobreMi/guardarInfoSobreMi'),
      formData
    );
  }

  getSocialNetworkList(idUsuario: number, idioma: string): Observable<any> {
    const body = { idUsuario, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelSobreMi/comboRedesSociales'),
      body,
      headers
    );
  }

  removeSocialNetwork(
    idRedTarjeta: number,
    idTarjeta: number,
    idUsuario: number,
    idioma: string
  ): Observable<any> {
    const body = { idRedTarjeta, idTarjeta, idUsuario, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelSobreMi/redesSocialesEliminar'),
      body,
      headers
    );
  }

  getSocialNetworks(
    idTarjeta: number,
    idUsuario: number,
    idioma: string
  ): Observable<any> {
    const body = { idTarjeta, idUsuario, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelSobreMi/consultarRedesSociales'),
      body,
      headers
    );
  }

  createSocialNetwork(body: SocialNetworks): Observable<any> {
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelSobreMi/redesSocialesGuardar'),
      body,
      headers
    );
  }

  deleteMedia(body: Gallery): Observable<any> {
    return this.http.post<any>(
      environment.api_qaapis.concat('api/PanelServicios/multimediaEliminar'),
      body,
      headers
    );
  }

  uploadGallery(body: any, count: string): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.post<any>(
      environment.api_qaapis.concat('api/PanelServicios/multimediaAgregar'),
      formData,
      {
        headers: new HttpHeaders({ multimedia: count }),
      }
    );
  }

  getIcons(): Observable<any> {
    return this.http.post<any>(
      environment.api_qaapis.concat('api/PanelServicios/getImagenes'),
      headers
    );
  }

  getTypeService(idUsuario: number, idioma: string): Observable<any> {
    const body = { idUsuario, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelServicios/comboTipoServicio'),
      body,
      headers
    );
  }

  saveService(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.post<any>(
      environment.api_qaapis.concat(
        'api/PanelServicios/tarjetaServiciosGuarda'
      ),
      formData
    );
  }

  removeService(body: any): Observable<any> {
    return this.http.post<any>(
      environment.api_qaapis.concat(
        'api/PanelServicios/tarjetaServiciosEliminar'
      ),
      body,
      headers
    );
  }
}
